import { render } from "./DocumentClassExportInterface.vue?vue&type=template&id=0add88dc&scoped=true&ts=true"
import script from "./DocumentClassExportInterface.vue?vue&type=script&lang=ts"
export * from "./DocumentClassExportInterface.vue?vue&type=script&lang=ts"

import "./DocumentClassExportInterface.vue?vue&type=style&index=0&id=0add88dc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0add88dc"]])

export default __exports__